var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect } from 'react';
import * as paths from '../../Header/constants/paths';
export var useProfile = function (_a) {
    var initialProfile = _a.initialProfile, getProfile = _a.getProfile;
    var _b = __read(useState(initialProfile !== null && initialProfile !== void 0 ? initialProfile : null), 2), profile = _b[0], setProfile = _b[1];
    useEffect(function () {
        if (profile)
            return;
        fetch(paths.PROFILE)
            .then(function (result) { return result.json(); })
            .then(function (profile) {
            if (getProfile)
                getProfile(profile);
            setProfile(profile);
        })
            .catch(console.error);
    }, [getProfile, profile]);
    return profile;
};
//# sourceMappingURL=useProfile.js.map